import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { Relation } from '../../../store/entities/relations/relations.types';
import { APIManagerConfig } from '../apiManager';

const RelationsServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getRelations: (roles?: string): Promise<Relation[]> =>
      HTTPBase.get(`farm/${config.farmId}/relations`, { params: { roles } }).then((res) => res.data),
    createRelation: (payload: Partial<Relation>, formName: FormName): Promise<Relation> =>
      HTTPBase.post(`farm/${config.farmId}/relations`, payload, { headers: { formName } }).then((res) => res.data),
    updateRelation: (id: string, payload: Partial<Relation>, formName: FormName): Promise<Relation> =>
      HTTPBase.patch(`farm/${config.farmId}/relations/${id}`, payload, { headers: { formName } }).then(
        (res) => res.data,
      ),
    deleteRelation: (id: string, formName: FormName): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/relations/${id}`, { headers: { formName } }).then((res) => res.data),
  };
};

export default RelationsServiceFactory;
